<template>
  <v-main v-if="$mq !== 'small' && $mq !== 'medium'">
    <v-container flex-column fill-height>
      <v-layout align-center justify-center>
        <v-flex class="reset-password">
          <v-card class="login--form" outlined>
            <validation-observer
              tag="form"
              ref="resetpassword"
              class="reset-password--form"
              @submit.prevent="onSubmit()"
            >
              <div class="h1">Reset your password</div>
              <div class="h3">
                We’ll email you a link to reset your password
              </div>
              <v-form>
                <validation-provider
                  v-slot="{ errors }"
                  rules="email|required"
                  name="email"
                  tag="div"
                  class="input-group reset-password--form-group"
                >
                  <div class="small-extra-bold apioshade2--text ">Email address</div>
                  <v-text-field
                    :class="{ 'reset-password--field-error': errors[0] }"
                    dense
                    outlined
                    :error="true"
                    required
                    v-model="email"
                    placeholder="Type here..."
                    autocomplete="username email"
                    :hide-details="true"
                  >
                  </v-text-field>
                  <transition name="fade">
                    <div class="form-field-error" style="height: 24px">
                      <div class="error-icon" v-if="errors[0]" />
                      <div>{{ errors[0] }}</div>
                    </div>
                  </transition>
                </validation-provider>

                <v-card-actions>
                  <apio-button
                    class="reset-password--reset-password"
                    @click="onSubmit()"
                    >Reset password</apio-button
                  >
                  <apio-button
                    button-type="secondary"
                    class="reset-password--not-now"
                    @click="$emit('login-section', 'login')"
                    >Not now</apio-button
                  >
                </v-card-actions>
              </v-form>
            </validation-observer>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
  <v-main v-else>
    <v-container>
      <v-layout align-center justify-center flex-column>
        <v-flex class="reset-password-mobile">
          <v-card class="login--form" outlined>
            <validation-observer
              tag="form"
              ref="resetpassword"
              class="reset-password--form"
              @submit.prevent="onSubmit()"
            >
              <div class="h1">Reset your password</div>
              <div class="h3">
                We’ll email you a link to reset your password
              </div>
              <v-form>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|min:2"
                  name="email"
                  tag="div"
                  class="input-group reset-password--form-group"
                >
                  <div class="small-extra-bold apioshade2--text ">Email address</div>
                  <v-text-field
                    class="reset-password--email"
                    :class="{ 'reset-password--field-error': errors[0] }"
                    dense
                    outlined
                    :error="true"
                    required
                    v-model="email"
                    placeholder="Type here..."
                    autocomplete="username email"
                    :hide-details="true"
                  >
                  </v-text-field>
                  <transition name="fade">
                    <div class="form-field-error" style="height: 24px">
                      <div class="error-icon" v-if="errors[0]" />
                      <div>{{ errors[0] }}</div>
                    </div>
                  </transition>
                </validation-provider>

                <v-card-actions>
                  <apio-button
                    class="reset-password--reset-password"
                    @click="onSubmit()"
                    >Reset password</apio-button
                  >

                  <apio-button
                    button-type="secondary"
                    class="reset-password--not-now"
                    @click="$emit('login-section', 'login')"
                    >Not now</apio-button
                  >
                </v-card-actions>
              </v-form>
            </validation-observer>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "ResetPassword",
  data: () => ({
    email: "",
    password: "",
  }),
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  methods: {
    async onSubmit() {
      const valid = await this.$refs.resetpassword.validate();
      if (valid) {
        this.resetPassword();
      }
    },
    resetPassword() {
      this.$store.dispatch("forgotPassword", this.email);
    },
  },
};
</script>

<style scoped lang="scss">
apio-button {
  text-transform: none !important;
}

::v-deep .v-card__actions {
  flex-direction: column;
}

.theme--light.v-application {
  background: transparent;
}

.form-field-error {
  display: flex;
  visibility: visible;
}

.h3 {
  font-weight: normal;
  color: var(--apio-shade-2);
  margin-bottom: 40px;
}

.h1 {
  color: var(--apio-shade-2);
  margin-bottom: 8px;
}

.container {
  padding: 0;
}

.v-messages {
  position: absolute !important;
  top: -16px;
}

.v-input__prepend-inner {
  height: 16px !important;
}

.v-sheet--outlined {
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-sheet.v-card {
  border-radius: 0;
  height: 576px;

  @media only screen and (max-width: 763px) {
    height: 100%;
    padding: 40px 20px;
    width: 100%;
  }
}

.apio {
  &--panel {
    width: 384px;
    height: 576px;

    &-mobile {
      width: calc(100vw);
      height: 393px;
      display: inline-flex;
      align-items: center;
      padding: 0 !important;
      margin: 0 !important;

      &-inner {
        display: flex;
        flex-direction: column;
        background-color: rgba(0, 0, 0, 0.35);
        padding: 0 !important;
        margin: 0 !important;
        height: 393px !important;
        width: 100%;
      }
    }

    &-inner {
      display: flex;
      flex-direction: column;
      background-color: rgba(0, 0, 0, 0.35);

      @media only screen and (max-width: 763px) {
        height: 439px;
        padding: 0 20px;
        width: 100%;
      }
    }
  }
}

.reset-password {
  width: 384px;
  height: 576px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  &-mobile {
    width: 320px;
    margin: 40px 20px 0;
  }

  &--heading {
    margin: 0 0 16px 0;
  }

  &--reset-password {
    margin-top: 12px;
    width: 100%;
    text-transform: none;
  }

  &--not-now {
    margin-top: 12px;
    width: 100%;
    text-transform: none;
  }

  &--field {
    &-error {
      border: 1px solid var(--apio-error);
    }
  }

  &--form {
    position: relative;
    width: 305px;

    &-mobile {
      width: 320px;
    }

    &-title {
      margin-bottom: 16px;
    }

    &-group {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-items: stretch;
      width: 100%;
      position: relative;
      margin: 0 0 1rem 0;
    }

    &-error {
      position: absolute;
      left: 0;
      bottom: -1.2rem;
      color: #dc3545;
      font-size: 12px;
    }
  }
}
</style>
